import { useState, useCallback, useEffect, useMemo } from 'react';
import { NotificationType, NotificationAction } from '../components/ModernNotification';

export interface NotificationOptions {
  title: string;
  message: string;
  type?: NotificationType;
  duration?: number;
  actions?: NotificationAction[];
}

export const useModernNotification = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState<NotificationType>('info');
  const [duration, setDuration] = useState(5000);
  const [actions, setActions] = useState<NotificationAction[]>([]);

  const showNotification = useCallback((options: NotificationOptions) => {
    console.log('[useModernNotification] showNotification appelé:', options);
    const {
      title: newTitle,
      message: newMessage,
      type: newType = 'info',
      duration: newDuration = 5000,
      actions: newActions = [],
    } = options;

    setTitle(newTitle);
    setMessage(newMessage);
    setType(newType);
    setDuration(newDuration);
    setActions(newActions);
    setIsOpen(true);
  }, []);

  const hideNotification = useCallback(() => {
    console.log('[useModernNotification] hideNotification appelé');
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (isOpen && duration > 0) {
      console.log('[useModernNotification] Temporisation démarrée:', { duration });
      const timer = setTimeout(() => {
        setIsOpen(false);
      }, duration);
      return () => {
        console.log('[useModernNotification] Temporisation annulée');
        clearTimeout(timer);
      };
    }
  }, [isOpen, duration]);

  return useMemo(
    () => ({
      isOpen,
      title,
      message,
      type,
      duration,
      actions,
      showNotification,
      hideNotification,
    }),
    [isOpen, title, message, type, duration, actions, showNotification, hideNotification]
  );
};

export default useModernNotification;